<template>
    <div class="chat-body-head" :class="{'active-info' : isActiveUserInfo && !isDesktop && !miniChat}">
        <div class="chat-body-head__info" :class="{'mini': miniChat, 'search-active': isActiveSearchResult && isActiveSearchMsg}" >
            <div class="chat-body-head__info-top">
                <div class="chat-body-head__info-left" v-if="!isActiveSearchMsg">
                    <div class="chat-body-head__back" v-if="(!isHideUserList && miniChat) || isMobile" @click="$emit('back')">
                        <svg v-once class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>            
                    </div>
                    <template v-if="isMiniChatLoad">
                        <a :href="currentUser?.user.public_profile_url" target="_blank" class="chat-body-head__info-img">
                            <ChatAvatar :url="currentUser?.user?.avatar || ''" :name="currentUser?.user?.username || ''" :supportName="supportName" :size="36"/>
                            <div class="online-status">
                                <div class="ico-user-status online" v-if="currentUser?.user.img ? currentUser.user.is_online : true"></div>
                            </div>
                        </a>
                    </template>
                    <div class="chat-body-head__info-img skeleton-img" v-else>
                        <div class="skeleton"></div>
                    </div>
                    <div class="chat-body-head__info-name" v-if="isMiniChatLoad">
                        <a :href="currentUser?.user.public_profile_url" target="_blank" 
                            :class="{'name-mute': currentUser?.is_mute, 'long-text': currentUser?.user?.username.length > 10 && miniChat}" 
                            class="user-name">
                            <span class="user-name__name" :data-text="currentUser?.user.username && miniChat ? currentUser.user.username : ''">{{currentUser?.user.username ? currentUser.user.username : supportName}}</span>
                            <svg v-if="!currentUser?.user?.username" class="wc-i is-official" role="img" :aria-label="$t('Official')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>
                            <svg v-if="currentUser?.is_mute" class="wc-i svg-mute" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"/><path d="M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/><path d="m2 2 20 20"/></svg>
                        </a>
                        <svg v-if="currentUser?.is_mute && currentUser?.user?.username.length > 10 && miniChat" class="wc-i svg-mute" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"/><path d="M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/><path d="m2 2 20 20"/></svg>
                        <p class="user-status" :class="{'online': currentUser?.user.img ? currentUser?.user.is_online : true }">
                            <span v-if="currentUser?.user.img ? currentUser.user.is_online : true">{{ $t("Online") }}</span>
                            <span class="last-seen" v-else-if="currentUser.user.last_seen">
                                {{ lastSeenUser(currentUser.user.last_seen) }}
                            </span>
                            <span class="last-seen" v-else>{{ $t("Offline") }}</span>
                        </p>
                    </div>
                    <div class="chat-body-head__info-name skeleton-name" v-else>
                        <span class="user-name skeleton"></span>
                        <p class="user-status skeleton"></p>
                    </div>
                </div>
                <div class="chat-body-head__info-right" :class="{'active-search': isActiveSearchMsg}">
                    <ChatBodySearch
                        :isActiveSearchMsg="isActiveSearchMsg"
                        :currentUserUuid="currentUserUuid"
                        :testUrlQuickChat="testUrlQuickChat"
                        :miniChat="miniChat"
                        @active-search-result="$emit('active-search-result-head', $event)"
                        @find-message="openFindMessage"
                        @toggle-search="toggleSearch"/>
                    <div class="chat-body-head__info-userInfo" v-if="!isMobile && !miniChat && currentUser" :class="{'active' : isActiveUserInfo, 'not-active': isLoadingMessages}" @click="$emit('toggle-info-head')">
                        <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M15 3v18"/></svg>
                    </div>
                    <div class="chat-body-head__info-tooltip" :class="{'no-touch': activeTooltipBody, mini: miniChat, active: isActiveTooltipInfo}" @click="toogleTooltipInfo">
                        <svg v-once class="wc-i tooltip-icon" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                        <div class="tooltip-body" v-if="isMiniChatLoad">
                            <a :href="`/chats?uuid=${currentUserUuid}&user_id=${currentUser.user.id}`" target="_blank" class="tooltip-body__row full" v-if="miniChat">
                                <svg v-once class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="m21 3-7 7"/><path d="m3 21 7-7"/><path d="M9 21H3v-6"/></svg>                
                                <p>{{ $t("Full screen") }}</p>
                            </a>
                            <div class="tooltip-body__row sidebar" @click="$emit('toggle-info-head')" v-if="isMobile && currentUser && !miniChat">
                                <svg v-once class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M15 3v18"/></svg>          
                                <p>{{ $t("View details") }}</p>
                            </div>
                            <MuteUser @user-mute="userMute" :isUserMute="currentUser?.is_mute" :userId="currentUserUuid" :longText="true"/>
                            <ReportUser :userId="currentUserUuid" :miniChat="miniChat"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import ChatAvatar from './ChatAvatar.vue';
import ChatBodySearch from './ChatBodySearch.vue';
import MuteUser from './MuteUser.vue';
import ReportUser from './ReportUser.vue';

  export default {
    components: {
      ChatAvatar,
        ChatBodySearch,
        MuteUser,
        ReportUser
    },
    props: {
        testUrlQuickChat: {
            type: String,
            default: ''
        },
        supportImg: {
            type: String,
            default: ''
        },
        currentUser: {
            type: Object,
            required: false
        },
        isLoadingMessages: {
            type: Boolean,
            default: false
        },
        isEnableInfo: {
            type: Boolean,
            default: false
        },
        isHideUserList: {
            type: Boolean,
            default: false
        },
        currentUserUuid: {
            type: String,
            required: true
        },
        isTablet: {
            type: Boolean,
            default: false
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        isDesktop: {
            type: Boolean,
            default: false
        },
        miniChat: {
            type: Boolean,
            default: false
        },
        activeTooltipBody: {
            type: Boolean,
            default: false
        },
        isActiveUserInfo: {
            type: Boolean,
            default: false
        },
        isActiveSearchMsg: {
            type: Boolean,
            default: false
        },
        isSeller: {
            type: Boolean,
            default: false
        },
        isActiveSearchResult: {
            type: Boolean,
            default: false
        },
        supportName: {
            type: String,
            default: ''
        },
        isMiniChatLoad: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        isActiveTooltipInfo: false
      };
    },
    methods: {
        onImgError(event) {
            event.target.src = this.supportImg;
        },
        lastSeenUser(lastSeen) {
            if (!lastSeen) return '';

            const now = new Date();
            const seen = new Date(lastSeen);

            const diff = now - seen;
            const diffHours = Math.floor(diff / (1000 * 60 * 60));

            if (diffHours < 24) {
                if (diffHours < 1) {
                const diffMinutes = Math.floor(diff / (1000 * 60));
                
                return this.miniChat || this.isMobile ? this.$t('Last seen {min} m ago', {min: diffMinutes}) : this.$t('Last seen {min} minutes ago', {min: diffMinutes})
                }
                return this.miniChat || this.isMobile ? this.$t('Last seen {hours} h ago', {hours: diffHours}) : this.$t('Last seen {hours} hours ago', {hours: diffHours})
            }

            const day = String(seen.getDate()).padStart(2, '0');
            const month = String(seen.getMonth() + 1).padStart(2, '0');
            const year = seen.getFullYear();

            return this.$t('Last seen {date}', {date: day + '.' + month+ '.'+ year})
        },
        userMute(id, isMute) {
            if (this.currentUser && id === this.currentUserUuid) {
                this.$emit('user-mute', {
                    userId: id,
                    isMute: isMute
                });
            }
        },
        toogleTooltipInfo() {
            if (this.isTablet) {
                this.isActiveTooltipInfo = !this.isActiveTooltipInfo;
            }
        },
        openFindMessage(id) {
            this.$emit('message-find', id)
        },
        toggleSearch(bool) {
            this.$emit('toggle-search-head', bool)
        }
    }
  };
</script>

<style lang="scss" scoped>
    .order-conversiation-enter-active,
    .order-conversiation-leave-active {
        transition: max-height 0.4s ease, opacity 0.3s ease;
        overflow: hidden;
    }
    .order-conversiation-enter-from,
    .order-conversiation-leave-to {
        max-height: 0;
        opacity: 0;
    }
    .order-conversiation-enter-to,
    .order-conversiation-leave-from {
        max-height: 45px; 
        opacity: 1;
    }
    .chat-body-head{
        position: absolute;
        left: 0;
        top: 0;
        //position: relative;
        width: 100%;
        padding: 0;
        z-index: 7;
        background: var(--wc-surface);
        border-bottom: 1px solid var(--wc-border);
        &.active-info{
          .chat-body-head__info{
            width: calc(100% - 320px);
          }
          .chat-body-head__orders-right{
            gap: 20px;
          }
        }
        &__orders{
            z-index: 7;
            width: calc(100% + 2px);
            height: 45px;
            position: relative;
            overflow: hidden;
            &-wrap{
                display: flex;
                cursor: pointer;
                gap: 33px;
                padding: 10px 24px 10px 20px;
            }
            &-left{
                display: flex;
                align-items: center;
                gap: 10px;
            }
            &-icon{
                border-radius: 50%;
                border: 0.66px solid var(--wc-accent-border);
                background: var(--wc-accent-soft);
                width: 25px;
                height: 25px;
                min-width: 25px;
                display: flex;
                align-items: center;
                justify-content: center;
                &.close-dispute,
                &.delivered{
                    background: var(--wc-success-soft);
                    border: 0.66px solid var(--wc-success);
                    :deep(.wrap){
                        width: 15px;
                        height: 15px;
                        min-width: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: var(--wc-success);
                        border-radius: 50%;
                        padding-left: 1px;
                    }
                }
                &.close-dispute-red{
                    background: var(--wc-danger-soft);
                    border: 0.66px solid var(--wc-danger-soft);
                    :deep(.wrap){
                        width: 16px;
                        height: 16px;
                        min-width: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: var(--wc-danger-soft);
                        border-radius: 50%;
                    }
                }
            }
            &-title{
                display: flex;
                flex-direction: column;
                h3{
                    font-family: "Roboto-Regular";
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0px;
                    color: var(--wc-text-2);
                    margin: 0;
                    white-space: nowrap;
                }
            }
            &-progress{
                display: flex;
                align-items: center;
                gap: 5px;
                width: 100%;
                max-width: 565px;
                span{
                    width: 100%;
                    height: 4px;
                    background: var(--wc-surface-2);
                    border-radius: 4px;
                    background-size: 200% !important;
                }
                @keyframes wave-placeholder {
                    from {
                        background-position: 100% 0%;
                    }
                    to {
                        background-position: -100% 0%;
                    }
                }
                &.delivery{
                    .progres-1{
                        background: var(--wc-accent-soft);
                    }
                    .progres-2{
                        background: linear-gradient(90deg, var(--wc-skeleton-1) 0% 25%, var(--wc-skeleton-2) 50%, var(--wc-skeleton-1) 65% 100%);
                        animation: 1s wave-placeholder infinite linear !important;
                    }
                }
                &.verification{
                    .progres-1{
                        background: linear-gradient(90deg, var(--wc-skeleton-1) 0% 25%, var(--wc-skeleton-2) 50%, var(--wc-skeleton-1) 65% 100%);
                        animation: 1s wave-placeholder infinite linear !important;
                    }
                }
                &.delivered{
                    .progres-1,
                    .progres-2,
                    .progres-3{
                        background: var(--wc-success-soft);
                    }
                    // .progres-3{
                    //     background: linear-gradient(90deg, var(--wc-accent-soft) 0% 25%, var(--wc-accent) 50%, var(--wc-accent-soft) 65% 100%);
                    //     animation: 1s wave-placeholder infinite linear !important;
                    // }
                }
                &.close-dispute-red,
                &.close-dispute{
                    .progres-1,
                    .progres-2,
                    .progres-3{
                        background: var(--wc-success-soft);
                    }
                }
            }
            &-right{
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 50px;
                width: 100%;
                transition: 0.6s;
                &-line{
                    width: 1px;
                    height: 22px;
                    background: var(--wc-bg);
                }
            }
            &.mini .chat-body-head__orders{
                &-wrap{
                    gap: 10px;
                    padding: 10px 16px;
                }
                &-title h3{
                    font-size: 14px;
                }
                &-right{
                    gap: 10px;
                }
            }
        }
        &__back{
            padding-right: 10px;
            display: flex;
            align-items: center;
            svg path{
                transition: 0.4;
            }
            &:hover{
                fill: var(--wc-text);
            }
        }
        &__info{
            z-index: 3;
            width: 100%;
            position: relative;
            background-color: var(--wc-surface);
            transition: width 0.6s ease;
            // &::before{
            //   border-radius: 30px;
            //   content: '';
            //   position: absolute;
            //   top: 0;
            //   left: 0;
            //   width: 100%;
            //   transition: 0.6s ease;
            //   height: 100%;
            //   background-color: var(--wc-overlay);
            //   box-shadow: 0px 4px 14px 0px #00000026;
            //   border: 1px solid #2B3545;
            //   z-index: 1;
            // }
            &.order-active,
            &.search-active{
            // border-radius: 30px 30px 0 0;
            border-bottom: none;
            //  &::before{
            //   border-bottom: none;
            //  }
            }
            // &.order-active{
            //   margin-top: -80px;
            //   @media only screen and (max-width: 767px) {
            //     margin-top: -61px;
            //   }
            // }
            &-top{
            height: 56px;
            padding: 0 12px 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            position: relative;
            z-index: 8;
            @media only screen and (max-width: 767px) {
                padding: 0 8px 0 8px;
            }
            }
            &.mini .chat-body-head__info-top{
            padding: 0 8px;
            }
            &-left{
            display: flex;
            align-items: center;
            cursor: pointer;
            min-width: 0;
            width: 100%;
            z-index: 8;
            }
            &-right{
            position: relative;
            display: flex;
            align-items: center;
            gap: 4px;
            z-index: 8;
            //transition: 0.6s ease;
            justify-content: flex-end;
            &.active-search {
                width: 100%;
            }
            }
            &-userInfo{
            cursor: pointer;
            background-color: transparent;
            width: 32px;
            min-width: 32px;
            height: 32px;
            border-radius: 8px;
            transition: background-color 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 3;
            &.not-active{
                pointer-events: none;
            }
            svg{
                width: 18px;
                height: 18px;
                path{
                transition: 0.3s;
                fill: var(--wc-text-2);
                }
            }
            &:hover{
                @media only screen and (min-width: 1023px) {
                background-color: var(--wc-bg);
                }
            }
            &.active{
                background-color: var(--wc-accent-soft);
                svg{
                path{
                    fill: var(--wc-accent);
                }
                }
            }
            }
            &-tooltip{
                cursor: pointer;
                background-color: transparent;
                width: 32px;
                min-width: 32px;
                height: 32px;
                border-radius: 8px;
                transition: background-color 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                z-index: 1;
                &.no-touch{
                    pointer-events: none;
                }
            @media only screen and (max-width: 1023px) {
                width: 40px;
                min-width: 40px;
                height: 40px;
            }
            .tooltip-icon path{
                transition: 0.4s;
            }
            .tooltip-body{
                opacity: 0;
                border-radius: 10px;
                transform: scale(0.5);
                transition: 0.3s;
                pointer-events: none;
                position: absolute;
                min-width: 200px;
                padding: 4px;
                top: 40px;
                right: 0;
                z-index: 15;
                border: 1px solid var(--wc-border);
                box-shadow: 0 12px 32px var(--wc-shadow-strong);
                background: var(--wc-surface);
                transform-origin: top right;
                // &::before{
                //   content: "";
                //   position: absolute;
                //   right: 16px;
                //   top: -6px;
                //   width: 12px;
                //   height: 12px;
                //   background: #354051;
                //   -webkit-transform: rotateZ(45deg);
                //   transform: rotateZ(45deg);
                //   z-index: -1;
                // }
                &::after{
                    content: '';
                    position: absolute;
                    top: -40px;
                    height: 40px;
                    width: 100%;
                    right: 0;
                    z-index: 1;
                    @media only screen and (max-width: 1023px) {
                        height: 100vh;
                        width: 100vh;
                        right: -100px;
                        top: -100px;
                    }
                }
                &__row{
                position: relative;
                z-index: 2;
                display: flex;
                align-items: center;
                gap: 10px;
                height: 36px;
                padding: 0 10px;
                border-radius: 6px;
                transition: 0.3s;
                svg{
                    width: 16px;
                    height: 16px;
                }
                &:hover{
                    background: var(--wc-bg);
                    svg{
                    path{
                        fill: var(--wc-text);
                    }
                    }
                    p{
                    color: var(--wc-text);
                    }
                }
                svg{
                    path{
                    transition: 0.3s;
                    }
                }
                p{
                    margin: 0;
                    transition: 0.3s;
                    font-family: var(--wc-font);
                    font-weight: 400;
                    font-size: 13px;
                    white-space: nowrap;
                    line-height: 18px;
                    color: var(--wc-text);
                }
                }
            }
            &:hover{
                @media only screen and (min-width: 1024px) {
                    background-color: var(--wc-bg);
                }
            }
            &.active{
                .tooltip-body{
                opacity: 1;
                transform: scale(1);
                pointer-events: all;
                }
                .tooltip-icon path{
                fill: var(--wc-text);
                }
            }
            &:hover{
                @media only screen and (min-width: 1024px) {
                .tooltip-body{
                    opacity: 1;
                    transform: scale(1);
                    pointer-events: all;
                }
                .tooltip-icon path{
                    fill: var(--wc-text);
                }
                }
            }
            
            }
            &-img{
                width: 36px;
                height: 36px;
                min-width: 36px;
                min-height: 36px;
                position: relative;
                margin-right: 12px;
            // @media only screen and (max-width: 1023px) {
            //   width: 40px;
            //   height: 40px;
            //   min-width: 40px;
            //   min-height: 40px;
            // }
            &.skeleton-img{
                .skeleton{
                width: 100%;
                height: 100%;
                border-radius: 100%;
                background: #EEF0F3 !important;
                animation: wc-head-skeleton-pulse 1.4s ease-in-out infinite;
                }
            }
            img{
                width: 100%;
                height: 100%;
                border-radius: 100%;
                overflow: hidden;
                object-fit: cover;
                -webkit-user-drag: none;
                user-drag: none;
                user-select: none;
            }
            .online-status{
                position: absolute;
                right: -1px;
                bottom: -1px;
                width: 10px;
                height: 10px;
                border-radius: 100%;
                .ico-user-status{
                width: 100%;
                height: 100%;
                border-radius: 100%;
                box-sizing: border-box;
                border: 2px solid var(--wc-surface);
                background: var(--wc-online);
                }
            }
            }
            &-name{
                max-height: 40px;
                display: flex;
                flex-direction: column;
                min-width: 0;
                padding-right: 5px;
                width: 100%;
                position: relative;
            &.skeleton-name{
                gap: 6px;
                .user-name{
                width: 120px;
                height: 10px;
                padding-bottom: 0;
                }
                .user-status{
                width: 64px;
                height: 8px;
                }
                .skeleton{
                background: #EEF0F3 !important;
                border-radius: 4px;
                animation: wc-head-skeleton-pulse 1.4s ease-in-out infinite;
                }
            }
            .svg-mute{
                position: absolute;
                right: -15px;
                top: 5px;
                z-index: 11;
            }
            .user-name{
                display: flex;
                align-items: center;
                margin-bottom: 0;
                text-decoration: none;
                min-width: 0;
                width: 100%;
                .svg-mute{
                    position: static;
                }
                &__referal{
                    margin-left: 10px;
                    width: 20px;
                    height: 20px;
                    min-width: 20px;
                    background-color: var(--wc-danger);
                    border-radius: 6.4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    &-tooltip{
                        position: absolute;
                        top: calc(100% + 5px);
                        left: 0;
                        background-color: var(--wc-surface-2);
                        padding: 12px 15px;
                        border-radius: 12px;
                        opacity: 0;
                        pointer-events: none;
                        transition: opacity 0.4s;
                        font-family: "Roboto-Regular";
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 140%;
                        color: var(--wc-text-2);
                        width: 262px;
                        &.mini{
                            right: 0;
                            left: unset;
                            width: 140px;
                        }
                        :deep(span){
                            font-family: 'Roboto-Medium';
                        }
                    }
                    img{
                        width: 12px;
                        height: 12px;
                    }
                    &:hover{
                        .user-name__referal-tooltip{
                            pointer-events: all;
                            opacity: 1;
                        }
                    }
                }
                &.long-text{
                    -webkit-mask-image: linear-gradient(90deg, black 90%, transparent);
                    &:hover{
                        -webkit-mask-image: linear-gradient(
                            90deg,
                            transparent 0%,
                            black 10%,
                            black 90%,
                            transparent 100%
                            );
                        span{
                            animation: textAnimationName 10s linear infinite;
                        }
                    }
                    &.name-mute{
                        .svg-mute{
                            display: none;
                        }
                    }
                    .user-name__name{
                        padding-right: 10px;
                        &:after {
                            content: attr(data-text);
                            position: absolute;
                            left: 100%;
                            top: 0;
                            white-space: nowrap;
                            pointer-events: none;
                            padding-right: 10px;
                        }
                    }
                }
                &__name{
                    font-family: var(--wc-font-medium);
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 20px;
                    color: var(--wc-text);
                    display: inline-block;
                    min-width: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    position: relative;
                }
                // Long names are truncated with an ellipsis (design) instead of the old marquee
                &.long-text{
                    -webkit-mask-image: none !important;
                    .user-name__name{
                        padding-right: 0;
                        animation: none !important;
                        &::after{
                            content: none !important;
                        }
                    }
                }
                // @media only screen and (max-width: 1023px) {
                //   margin-bottom: 0;
                // }
                svg{
                    margin-left: 5px;
                }
            }
            .user-status{
                margin: 0;
                font-family: var(--wc-font);
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: var(--wc-text-3);
                white-space: nowrap;
                &.online{
                color: var(--wc-success);
                }
            }
            }
            @keyframes textAnimationName {
                0% {
                    transform: translateX(0%);
                }

                20% {
                    transform: translateX(0%);
                }

                100% {
                    transform: translateX(-100%);
                }
            }
        }
      }

@keyframes wc-head-skeleton-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.55; }
}
</style>
